export default __webpack_public_path__ + "static/media/s5.7983f0d2.png";